import React from 'react'
import { Swipeable } from 'react-touch';

import postNavButtonImage from '../scss/imgs/posts-nav-buttton.svg'
import carImage from '../imgs/shop-category-car.svg'
import bikeImage from '../imgs/shop-category-bike.svg'
import voucherImage from '../imgs/shop-category-voucher.svg'
import { Link } from 'react-router-dom'

export default class ShopCategories extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            index: 0
        }
    }

    right() {
        this.setState({index: Math.min(this.state.index + 1, 2)})
    }

    left() {
        this.setState({index: Math.max(this.state.index - 1, 0)})
    }

    render() {
        let translateX = 0;
        if (this.state.index > 0) {
            translateX = window.innerWidth * -this.state.index;
        }

        return <section className="section gray-section on-screen">
            <div className="section-content">
                <div className="container">
                    <h1 className="text-center shop-title">Kategorie wählen</h1>
                    <Swipeable onSwipeLeft={() => this.right()} onSwipeRight={() => this.left()}>
                        <div ref="container" className="shop-category-list-container">
                            {this.state.index > 0 && (
                            <button type="button" className="shop-category-list-left" onClick={() => this.left()}>
                                <img src={postNavButtonImage} />
                            </button>
                            )}
                            {this.state.index < 2 && (
                            <button  type="button" className="shop-category-list-right" onClick={() => this.right()}>
                                <img src={postNavButtonImage} />
                            </button>
                            )}
                            <div ref="list" className="shop-category-list" style={{transform: "translateX("+translateX+"px)"}}>
                                <div className="shop-category">
                                    <div className="shop-category-image-container">
                                        <img className="img" src={carImage} alt="PKW-Training" />
                                    </div>
                                    <div className="shop-category-type">
                                        Buchung
                                    </div>
                                    <div className="shop-category-title">
                                        PKW-Training
                                    </div>
                                    <div className="shop-category-button">
                                        <button onClick={() => this.props.navigate("pkw")} className="btn">Jetzt buchen</button>
                                    </div>
                                </div>
                                <div className="shop-category">
                                    <div className="shop-category-image-container">
                                        <img className="img" src={bikeImage} alt="Motorrad-Training" />
                                    </div>
                                    <div className="shop-category-type">
                                        Buchung
                                    </div>
                                    <div className="shop-category-title">
                                        Motorrad-Training
                                    </div>
                                    <div className="shop-category-button">
                                        <button onClick={() => this.props.navigate("motorrad")} className="btn">Jetzt buchen</button>
                                    </div>
                                </div>
                                {!this.props.disableVoucher && (
                                <div className="shop-category">
                                    <div className="shop-category-image-container">
                                        <img className="img" src={voucherImage} alt="Wertgutschein" />
                                    </div>
                                    <div className="shop-category-type">
                                        Freier Betrag
                                    </div>
                                    <div className="shop-category-title">
                                        Wert&shy;gutschein
                                    </div>
                                    <div className="shop-category-button">
                                        {!this.state.voucher &&
                                        <button className="btn" onClick={() => this.setState({voucher: true})}>Jetzt buchen</button>
                                        }
                                        {this.state.voucher && [
                                            <Link key='amount' to="/shop/gutschein" className="btn">Freibetrag</Link>,
                                            <Link key='appointment' to="/shop/gutschein/kurs" className="btn">Kurs wählen</Link>
                                        ]}
                                    </div>
                                </div>
                                )}
                            </div>
                        </div>
                    </Swipeable>
                </div>
            </div>
        </section>
    }
}


// WEBPACK FOOTER //
// ./src/components/ShopCategories.jsx